var app_preloadPictures = null;
(function ($) {

    app_preloadPictures = function (pictureUrls, callback, animation) {
        var i = 0;
        var j = pictureUrls.length;
        var loaded = 0;
        var images = [];

        // $("body").append(images);


        for (i = 0, j = pictureUrls.length; i < j; i++) {
            var data = pictureUrls[i];
            var img = $('<img>');
            
            data.elm = img;

            if (data.main) {
                $("#view" + data.view).append(img);
            } else {
                $("#animation").append(img);
                img.addClass("animation");
                img.css({opacity:0});
                img.attr("data-index", data.index);
                img.attr("data-view", data.view);
            }

            // img.attr("src", data.url + "?data=" + (new Date().getTime()));
            img.attr("src", data.url);
        }

        //If app animation then run callback here
        if(animation){
            $("#animation").imagesLoaded().done(function () {
                callback();
            });
        }else{
            $("body").find(".view").imagesLoaded().done(function(){
                callback();
            });
        }
        
        
    };

})(jQuery);
